export enum EncryptionKeyEnum {
  AWS_AUTH = 'rbPR1EP0QeCX6o4d',
  AWS_AUTH_SALT = 'v26A3vctfz502QjH',

  REDUX_STORAGE = 'jNx20q2t9u1JcnDh',
  REDUX_STORAGE_SALT = 'kbqQ74p6GxE7rzhQ',

  DEFAULT_SALT = '8FmwZOU75s8O1DCt',
}
